import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class  MediaKit extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                <div className="website">
                    <section className="banner page-banner position-relative pb-0">
                        <div className="overlay"></div>
                        <div className="container">
                            <div className="page-title text-center position-relative py-9">
                                <h2 className="text-white text-uppercase mt-4">Media Kit</h2>
                            </div>
                        </div>
                    </section>
                    <section className="">
                        <div className="container">
                        <section className=" text-center py-5">
                            <div className="container">
                                {/* <h3 className="text-uppercase text-secondary">Coming Soon</h3>
                                <p className="text-muted mt-3">Stay tuned for updates. We're working hard to bring this to you soon!</p> */}
                               <img class="blog-img rounded-top media-kit-logo" src="static/images/logo.png" alt="Media kit" ></img>
                            </div>
                        </section>
                        </div>
                    </section>
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(MediaKit)
);
